import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { SupportPage, toSupportTab } from '@/components/support/support-page';

export const Route = createFileRoute('/support/$tab')({
  component: SupportTabPage,
});

function SupportTabPage() {
  const { tab } = Route.useParams();
  const navigate = useNavigate();
  // A URL naming no tab we have opens the board rather than a blank page, which
  // is what an old bookmark or a typo deserves — and the board is the half that
  // works with no account, so a stranger who mistypes still lands on something.
  return (
    <SupportPage
      tab={toSupportTab(tab)}
      onTabChange={(next) => {
        void navigate({ to: '/support/$tab', params: { tab: next } });
      }}
    />
  );
}
